import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// One mechanism for every email button that lands on a signed-in page with a
// "?<flag>=1" — the "One last step" email's Connect Instagram button is
// /requests?verify=1 (ReviewSheet). Act on it once, then drop the flag
// (replace: no new history entry) so a refresh or Back doesn't act again. The
// rest of the URL — other params, the #profile hash — stays as it was.
export function useLinkFlag(flag: string, onArrive: () => void): void {
  const location = useLocation();
  const navigate = useNavigate();
  // The latest callback, read when the flag shows up: a new function on every
  // render must not re-run the effect.
  const onArriveRef = useRef(onArrive);
  onArriveRef.current = onArrive;
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get(flag) !== "1") return;
    params.delete(flag);
    const rest = params.toString();
    navigate({ pathname: location.pathname, search: rest ? `?${rest}` : "", hash: location.hash }, { replace: true });
    onArriveRef.current();
  }, [flag, location.search, location.pathname, location.hash, navigate]);
}
